// Backend-driven pricing catalog. Fetches from /api/billing/plans/public and
// /api/billing/topups/public. `FALLBACK_*` values are kept purely as an
// offline-safe last resort while the network request is in flight — they
// must not be treated as authoritative and are never shown before the fetch
// resolves in normal operation.
import { api } from "./api";

// ---- Fallback shapes (structural only) ----
export const FALLBACK_TIERS = [
  { key: "hobbyist", name: "Hobbyist", blurb: "For the solo promoter getting started.",
    monthly: { plan_id: "hobbyist_monthly", amount: 15, credits: 30 },
    annual: { plan_id: "hobbyist_annual", amount: 144, credits: 360, per_month: 12 } },
  { key: "promoter", name: "Professional Promoter", blurb: "For working promoters shipping flyers weekly.", popular: true,
    monthly: { plan_id: "promoter_monthly", amount: 29, credits: 100 },
    annual: { plan_id: "promoter_annual", amount: 288, credits: 1200, per_month: 24 } },
  { key: "agency", name: "Agency & Venue", blurb: "For agencies and venues operating at scale.",
    monthly: { plan_id: "agency_monthly", amount: 79, credits: 400 },
    annual: { plan_id: "agency_annual", amount: 780, credits: 4800, per_month: 65 } },
];

export const FALLBACK_TOPUPS = [
  { id: "A", pack_id: "A", name: "50 Extra Credits", credits: 50, amount_full: 30, amount_member: 18 },
  { id: "B", pack_id: "B", name: "120 Extra Credits", credits: 120, amount_full: 60, amount_member: 36 },
];

export const PRO_PERKS = [
  "No watermark on any export",
  "PDF export + live share links",
  "AI Style Replication Studio",
  "Custom font uploads",
  "Full template marketplace",
];

// ---- Backend fetchers ----
export async function fetchTiers() {
  try {
    const r = await api.get("/billing/plans/public");
    if (r.data?.tiers?.length) return r.data.tiers;
  } catch (_) { /* fall through to fallback */ }
  return FALLBACK_TIERS;
}

export async function fetchTopups() {
  try {
    const r = await api.get("/billing/topups/public");
    if (r.data?.packs?.length) return r.data.packs;
  } catch (_) { /* fall through */ }
  return FALLBACK_TOPUPS;
}

export const planIdFor = (tiers, tierKey, billing) => {
  const t = (tiers || []).find((x) => x.key === tierKey);
  return t ? t[billing]?.plan_id : null;
};
